import React from 'react';
import {useNavigate} from 'react-router-dom';
import './Products.css';
import Header from "../Clientes/components/Header/Header";
import Footer from "../Clientes/components/Footer/Footer";
import {ReactComponent as RigthArrow} from '../../assets/systemIcons/rigth_arrow.svg';
import { trackClick, getElementName } from "../../utils/analytics/analytics";
import { ANALYTICS_MODULES, ANALYTICS_SECTIONS, ANALYTICS_ELEMENT_TYPES } from "../../constants/analyticsConstants";

const products = [
    {
        name: "Automotor",
        img: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/automotor.webp",
        link: "/cotizar/automotor",
    },
    {
        name: "Motovehículo",
        img: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/motovehiculo.webp",
        link: "/cotizar/motovehículo",
    },
    {
        name: "Hogar",
        img: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/hogar.webp",
        link: "/cotizar/hogar",
    },
    {
        name: "Asistencia al viajero",
        img: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/asistencia-al-viajero.webp",
        link: "/cotizar/asistenciaviajero",
    },
    {
        name: "Notebook",
        img: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/notebook.webp",
        link: "/cotizar/notebook",
    },
    {
        name: "Tablet",
        img: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/tablet.webp",
        link: "/cotizar/tablet",
    },
    {
        name: "Monopatín",
        img: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/monopatin.webp",
        link: "/cotizar/monopatin",
    },
    {
        name: "Bicicleta",
        img: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/bicicleta.webp",
        link: "/cotizar/bicicleta",
    },
    {
        name: "Robos varios",
        img: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/robosvarios.webp",
        link: "/cotizar/robosvarios",
    }
];

function Products() {
    const navigate = useNavigate();

    return (
        <main className="products__container">
            <Header/>
            <div className="products__bodyContainer">
                <h1 className="products__title">Nuestros productos</h1>
                <h2 className="products__description">
                    Cotizá el seguro que estás buscando y recibí ayuda de un productor experto.
                </h2>
                <div className="products__productsContainer">
                    {products.map((p, i) => {
                        // Convertir nombre del producto a snake_case para el tracking
                        const semanticName = p.name.toLowerCase()
                            .replace(/\s+/g, '_')
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, ''); // Eliminar acentos

                        return (
                            <button
                                key={i}
                                className="products__button"
                                onClick={() => {
                                    trackClick({
                                        module: ANALYTICS_MODULES.PRODUCTOS,
                                        section: ANALYTICS_SECTIONS.PRODUCTS_MAIN,
                                        elementName: getElementName(ANALYTICS_ELEMENT_TYPES.BUTTON, ANALYTICS_SECTIONS.PRODUCTS_MAIN, semanticName),
                                        elementType: ANALYTICS_ELEMENT_TYPES.BUTTON
                                    });
                                    navigate(p.link);
                                }}
                            >
                                <img
                                    src={p.img}
                                    alt={p.name}
                                    className="products__img"
                                />
                                <div className="products__contentContainer">
                                    <p className="products__buttonText">{p.name}</p>
                                    <RigthArrow className="products__arrow"/>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
            <Footer/>
        </main>
    );
}

export default Products;
